/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from 'react'
import { BannerDetails, ProfileDetails } from '../../core/_requests';
import { useAuth } from '../../../../auth';
interface timeProps {
  timing?: { data: any[] }
}
const ProfileLevelSettings: React.FC<timeProps> = ({ timing = { data: [] } }) => {
  const { currentUser } = useAuth();
  const chefId = currentUser?.uuid || "";
  const [listProfile, setListProfile] = useState<any>();
  const [banner, setBannerImage] = useState<string>("");
  useEffect(() => {
    ProfileDetails(chefId).then((res) => {
      setListProfile(res?.data);
    });
  }, [chefId]);

  useEffect(() => {
    BannerDetails(chefId)
      .then((res) => {
        if (Array.isArray(res?.data)) {
          setBannerImage(res?.data[0]); // Assuming you want the first item in the array
        } else {
          console.error("Expected banner data to be an array", res?.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching banner details:", error);
      });
  }, [chefId]);
  return (
    <div>
      <div className="col-12 mb-4">
        <div className="snippet-block">
          <div className="head">
            <h6 className="mb-0">
              Complete Your Profile
              <small className="mt-1">
                Create your own identity and stand out from the
                crowd
              </small>
            </h6>
            <div className="progress-count">
              {" "}
              {/* Calculate and display the completion percentage */}
              {listProfile &&
                listProfile.profile &&
                banner &&
                listProfile.chefProfile &&
                timing &&
                timing.data?.length > 0
                ? "100%"
                : `${(listProfile && listProfile.profile
                  ? 30
                  : 0) +
                (banner ? 20 : 0) +
                (listProfile && listProfile.chefProfile
                  ? 20
                  : 0) +
                (timing && timing.data?.length > 0 ? 30 : 0)
                }%`}
            </div>
          </div>
          <div className="cont">
            <ul className="list-unstyled progress-list">
              {/* <li className="done"> */}
              <li
                className={
                  listProfile && listProfile.profile
                    ? "done"
                    : ""
                }
              >
                <div className="d-flex align-items-center">
                  <img
                    className="ico"
                    src="/assets/images/circle-tick-filled-ico.svg"
                    alt="ico"
                  />
                  Add profile
                </div>
                <span className="level">
                  {" "}
                  {listProfile && listProfile.profile ? 30 : 0}%
                </span>
              </li>
              <li className={banner ? "done" : ""}>
                <div className="d-flex align-items-center">
                  <img
                    className="ico"
                    src="/assets/images/circle-tick-filled-ico.svg"
                    alt="ico"
                  />
                  Upload cover photo
                </div>
                <span className="level">
                  {" "}
                  {banner ? 20 : 0}%
                </span>
              </li>
              <li
                className={
                  listProfile && listProfile.chefProfile
                    ? "done"
                    : ""
                }
              >
                <div className="d-flex align-items-center">
                  <img
                    className="ico"
                    src="/assets/images/circle-tick-filled-ico.svg"
                    alt="ico"
                  />
                  Add short bio
                </div>
                <span className="level">
                  {listProfile && listProfile.chefProfile
                    ? 20
                    : 0}
                  %
                </span>
              </li>

              <li
                className={
                  timing && timing.data?.length > 0 ? "done" : ""
                }
              >
                <div className="d-flex align-items-center">
                  <img
                    className="ico"
                    src="/assets/images/circle-tick-filled-ico.svg"
                    alt="ico"
                  />
                  Add business timings
                </div>

                <span className="level">
                  {" "}
                  {timing && timing.data?.length > 0 ? 30 : 0}%
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileLevelSettings
